<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>User Administration</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <!--<v-layout>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Users w/o Roles (setup required)
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="newUserSearch"
                            append-icon="mdi-clipboard-text-search"
                            label="Filter"
                            single-line
                            hide-details>
                        </v-text-field>
                    </v-card-title>
                    <v-data-table
                        :headers="userTableHeaders"
                        :items="newUsers"
                        :search="newUserSearch"
                        footer-props.items-per-page-options="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]">
                        <template v-slot:item.auth0UserId="{item}">  this error is a lie
                            <td class="text-xs"><v-btn icon @click="editUser(item)"><v-icon color="tertiary">account_circle</v-icon></v-btn></td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>-->
        <v-layout>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        All Users
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="userTableSearch"
                            append-icon="mdi-clipboard-text-search"
                            label="Filter"
                            single-line
                            hide-details>
                        </v-text-field>
                    </v-card-title>
                    <v-card-actions>
                        <v-text-field id="firstNameSearch" label="First Name" v-model="searchDto.firstName"></v-text-field>
                        <v-text-field id="lastNameSearch" label="Last Name" v-model="searchDto.LastName"></v-text-field>
                        <v-text-field id="emailSearch" label="Email" v-model="searchDto.email"></v-text-field>
                        <v-select clearable label="Role" :items="userRoleList" item-value="id" item-text="description" v-model="searchDto.userRole"></v-select>
                        <v-btn @click="search()" color="tertiary">Search</v-btn>
                    </v-card-actions>
                    <v-data-table
                        :headers="userTableHeaders"
                        :items="userResults"
                        :search="userTableSearch"
                        footer-props.items-per-page-options="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]">
                        <template v-slot:item.userId="{item}"> <!-- this error is a lie-->
                            <td class="text-xs"><v-btn icon @click="editUser(item)"><v-icon color="tertiary">mdi-account-circle</v-icon></v-btn></td>
                            <!-- <td class="text-xs">{{ item.username }}</td>
                            <td class="text-xs">{{ item.firstName }}</td>
                            <td class="text-xs">{{ item.lastName }}</td>
                            <td class="text-xs">{{ item.roleName }}</td> -->
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-dialog v-model="userEditDialog" persistent no-click-animation max-width="900px">
                    <v-card>
                        <v-card-title class="title grey lighten-3" primary-title>
                            <div>Edit User</div>
                            <div>&nbsp;&nbsp;&nbsp;&nbsp;{{ selectedUser.email + " (" + selectedUser.auth0Method + ")" }}</div>
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="userForm" v-model="formValid">
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 py-1>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.firstName" label="First Name" :rules="[v => !!v || 'First Name is required']" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.lastName" label="Last Name" :rules="[v => !!v || 'Last Name is required']" required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-autocomplete autocomplete='no' chips deletable-chips multiple v-model="selectedUserRoleList"
                                                        :items="userRoleList" item-text="description" item-value="description" label="User Role(s)" placeholder="None" ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="showAgency">
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.managerName" label="Manager Name"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.managerEmail" label="Manager Email"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm12 px-1>
                                        <v-text-field v-model="selectedUser.accessRequestReason" label="Access Request Reason"></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-1>
                                        <v-select
                                            label="User Agency:"
                                            :clearable="true"
                                            v-model="selectedUser.agencyId"
                                            item-text="description"
                                            item-value="id"
                                            :items="agencies">
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.agencyDivision" label="Agency Division"></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 v-if="validationResult.messages && validationResult.messages.length > 0">
                                        <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="errors.length > 0">
                                    <v-flex xs12>
                                        <ul>
                                            <li v-for="error in errors" v-bind:key="error">{{error}}</li>
                                        </ul>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                        <v-card-actions py-1>
                            <template>
                                <v-btn color="error" @click="inactivateUser" v-if="(!selectedUser.roleList || selectedUser.roleList.length < 1) && selectedUser.isActive">Set Inactive</v-btn>
                                <v-btn color="error" @click="activateUser" v-if="!selectedUser.isActive">Set Active</v-btn>
                            </template>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="saveUser">Save User</v-btn>
                            <v-btn color="primary" @click="userEditDialog = false">Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import userService from '@/services/userService'
import lookupService from '@/services/lookupService'

export default {
    components: {
    },
    data: () => {
        return {
            //newUserSearch: '',
            //newUsers: [],
            userTableSearch: '',
            userResults: [],
            testData: {},
            userTableHeaders: [
                { text: 'Edit', sortable: 'false', value: 'userId' },
                { text: 'Email', value: 'email' },
                { text: 'Auth0 Method', value: 'auth0Method' },
                { text: 'First Name', value: 'firstName' },
                { text: 'Last Name', value: 'lastName' },
                { text: 'Is Active', value: 'isActive' },
                { text: 'VSS Username', value: 'vssUsername' },
                { text: 'Modified By', value: 'modifyUsername' },
                { text: 'Modified Date', value: 'modifyDate' }
            ],
            selectedUser: {
                email: '',
                firstName: '',
                lastName: '',
                isActive: true,
                modifyDate: '',
                modifyUsername: '',
                portalUserId: '',
                roleList: [],
                vssUsername: '',
                managerName: null,
                managerEmail: null,
                accessRequestReason: null,
                agencyId: null,
                auth0Method: ''
            },
            selectedUserRoleList: [],
            userRoleList: [],
            agencies: [],
            validationResult: '',
            formValid: true,
            userEditDialog: false,
            searchDto: {
                firstName: '',
                lastName: '',
                email: '',
                userRole: ''
            },
            errors: [],
            showAgency: false
        }
    },
    mounted: function () {
        this.loadData()
    },
    methods: {
        loadData () {
            // userService.searchNewUsers(this.$http, true).then(response => {
            //     this.newUsers = response.data
            // })
            this.userResults = []

            userService.listUserResultDtos(this.$http).then(response => {
                this.userResults = response.data
            })

            lookupService.GetUserRoles(this.$http).then(response => {
                this.userRoleList = response.data
            })

            lookupService.GetAgencies(this.$http).then(response => {
                this.agencies = response.data
            })
        },
        editUser (user) {
            this.selectedUser = user
            this.selectedUserRoleList = user.roleList

            this.showAgency = this.selectedUserRoleList.includes('Death Verification') ||
            this.selectedUserRoleList.includes('Death Insurance Verification') ||
            this.selectedUserRoleList.includes('Birth Verification') ||
            this.selectedUserRoleList.includes('Marriage Verification') ||
            this.selectedUserRoleList.includes('Divorce Verification')

            // need to get agency info for selected user
            userService.getUserAgency(this.$http, this.selectedUser.portalUserId).then(response => {
                if (response.data) {
                    this.selectedUser.agencyId = response.data.agencyId
                    this.selectedUser.managerName = response.data.managerName
                    this.selectedUser.managerEmail = response.data.managerEmail
                    this.selectedUser.accessRequestReason = response.data.accessRequestReason
                    this.selectedUser.agencyDivision = response.data.agencyDivision
                    this.showAgency = true
                }
                this.userEditDialog = true
            })
        },
        saveUser () {
            this.errors = []
            if (this.selectedUserRoleList.includes('Death Verification') && this.selectedUserRoleList.includes('Death Insurance Verification')) {
                this.errors.push('Cannot have both Death Verification and Death Insurance Verification')
            } else {
                this.selectedUser.newRoleList = this.selectedUserRoleList

                userService.saveUser(this.$http, this.selectedUser).then(response => {
                    // if user has agency info need to also save it
                    var agencyDto = {
                        portalUserId: this.selectedUser.portalUserId,
                        agencyId: this.selectedUser.agencyId === 0 ? null : this.selectedUser.agencyId,
                        managerName: this.selectedUser.managerName,
                        managerEmail: this.selectedUser.managerEmail,
                        accessRequestReason: this.selectedUser.accessRequestReason,
                        agencyDivision: this.selectedUser.agencyDivision
                    }
                    userService.updateUserAgency(this.$http, agencyDto).then(() => {
                        this.loadData()
                    })
                })

                this.userEditDialog = false
            }
        },
        inactivateUser () {
            userService.setUserInactive(this.$http, this.selectedUser.portalUserId).then(response => {
                this.loadData()
            })
            this.userEditDialog = false
        },
        activateUser () {
            userService.setUserActive(this.$http, this.selectedUser.portalUserId).then(response => {
                this.loadData()
            })
            this.userEditDialog = false
        },
        search () {
            userService.searchUsers(this.$http, this.searchDto).then(response => {
                this.userResults = response.data
            })
        }
    }
}
</script>
